import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './ProductInfo.style'

const ProductInfoVariationThirty = (props) => {
  const styles = useStyles()
  const { t } = props
  return (
    <Box
      style={{
        width: 'calc(30% - 10px)',
      }}
      className={styles.thirtyVariantRoot}
    >
      {props.icon}
      <Typography variant="h6">{t(props.title)}</Typography>
      <Typography variant="body2">{t(props.subtitle)}</Typography>
    </Box>
  )
}

export default ProductInfoVariationThirty
